var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.2756 13.7734H169.175",
    stroke: "#0B1D2E",
    strokeWidth: 14.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2756 66.8359H169.174",
    stroke: "#0B1D2E",
    strokeWidth: 14.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2756 119.898H111.968",
    stroke: "#0B1D2E",
    strokeWidth: 14.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7222 13.7754H13.7729",
    stroke: "#0B1D2E",
    strokeWidth: 14.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7222 66.8379H13.7729",
    stroke: "#0B1D2E",
    strokeWidth: 14.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7222 119.9H13.7729",
    stroke: "#0B1D2E",
    strokeWidth: 14.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M151.748 169.856V113.266C152.292 113.266 152.836 113.27 153.379 113.278C170.95 113.538 186.225 128.495 186.225 146.069",
    stroke: "#0B1D2E",
    strokeWidth: 14.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.382 186.227C145.86 186.227 151.754 180.335 151.754 169.856C151.754 159.379 145.86 153.486 135.382 153.486C124.905 153.486 119.011 159.379 119.011 169.856C119.011 180.335 124.905 186.227 135.382 186.227Z",
    stroke: "#0B1D2E",
    strokeWidth: 14.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.5c1b12dd67094f7c855ffabb8637c389.svg";
export { ForwardRef as ReactComponent };